import { render, staticRenderFns } from "./CaregiverDetails.vue?vue&type=template&id=9fc8466a&scoped=true"
import script from "./CaregiverDetails.vue?vue&type=script&lang=js"
export * from "./CaregiverDetails.vue?vue&type=script&lang=js"
import style0 from "./CaregiverDetails.vue?vue&type=style&index=0&id=9fc8466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc8466a",
  null
  
)

export default component.exports